import { Box, Button, Modal, Stack, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { DataGrid } from "@mui/x-data-grid";
import "./ProjectionEditModal.css";
const modalStyle = {
	width: 1200,
	bgcolor: "background.paper",
	boxShadow: 24,
	p: "10px 15px",
	borderRadius: 1,
};
const ProjectionEditModal = ({ modalOpen, setModalOpen, dataArr, setDataArr, columns = [] }) => {
	const handleRowDataChange = (updatedRow) => {
		return updatedRow;
	};
	const handleCancelClick = () => {
		setModalOpen(false);
	};
	const handleSaveClick = () => {};
	return (
		<Modal
			sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
			open={modalOpen}
			onClose={() => setModalOpen(false)}>
			<Stack sx={modalStyle} spacing={2} alignItems="center">
				<Box
					sx={{
						alignSelf: "center",
						alignItems: "center",
						justifyContent: "space-between",
						display: "flex",
						width: "100%",
					}}>
					<Typography variant="h6">Edit Projection Details</Typography>
					<Box>
						<Button onClick={handleCancelClick} variant="outlined" sx={{ mr: 1 }} size="small">
							Cancel
						</Button>
						<Button onClick={handleSaveClick} variant="contained" size="small">
							Save
						</Button>
					</Box>
				</Box>
				<DataGrid
					rows={dataArr ?? []}
					// isCellEditable={(params) => params.row.editable}
					columns={columns}
					getRowId={(row) => row.channel + row.brand}
					showCellVerticalBorder
					sx={{
						minHeight: 120,
						width: "100%",
						border: "none",
						"& .MuiDataGrid-row": {
							// borderBottom: "1px solid lightgray",
							cursor: "pointer",
							border: "none",
						},
						"& .MuiDataGrid-cell": {
							// borderBottom: "1px solid lightgray",
							padding: 0,
						},
						"& .MuiDataGrid-columnHeader": {
							cursor: "pointer",
							padding: 0,
							width: "100%",
							height: "100%",
						},
					}}
					columnHeaderHeight={35}
					rowHeight={30}
					processRowUpdate={handleRowDataChange}
					initialState={{
						pagination: {
							paginationModel: { pageSize: 10 },
						},
						// columns: {
						// 	columnVisibilityModel: {
						// 		total_pcs: false,
						// 		ltl_st: false,
						// 		new_st: false,
						// 	},
						// },
					}}
					disableRowSelectionOnClick
					pageSizeOptions={[15]}
				/>
			</Stack>
		</Modal>
	);
};

export default ProjectionEditModal;
